import "./Loader.scss"
import { CircularProgress } from "@mui/material"

interface ILoaderProps {
    size?: string | number
}

const Loader = (props: ILoaderProps) => {
    return (
        <CircularProgress size={props.size || "40px"} />
    )
}

export default Loader